import React, { useState } from "react";
import galleryImg1 from '../img/envision/healthcare/health3.jpg';
import { useNavigate } from "react-router-dom";

const Healthcareextradata = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  const navigate = useNavigate();

  const handleTabClick = (tab) => setActiveTab(tab);

  const handleKnowMoreClick = () => {
    navigate("/carrerspage"); // Replace with the actual route you want to navigate to
  };

  const styles = {
    knowMoreButton: {
      marginTop: "15px",
      padding: "10px 20px",
      backgroundColor: "rgb(236 115 34)",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "16px",
      transition: "background-color 0.3s",
      // marginLeft: "150px"
    },
    knowMoreButtonHover: {
      backgroundColor: "#e68a00",
    },
  };

  return (
    <section
      style={{
        width: '100vw',
        height: 'auto', // Adjusted for mobile view
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '550px',
        marginTop: '100px'
      }}
    >
      <div className="container-fluid healthcare-extra-data" style={{ padding: '0 50px' }}>
        <div className="row justify-content-center">
          <div className="col-12">
            <div
              className="card shadow-lg d-flex flex-row align-items-center health-extradata-ca"
              style={{
                borderRadius: '15px',
                backgroundColor: '#fff',
                width: '95%',
                maxWidth: '1600px',
                height: 'auto', // Adjusted height
                display: 'flex',
                flexDirection: 'row',
                padding: '50px',
                boxSizing: 'border-box',
                margin: 'auto'
              }}
            >
              {/* Image Section */}
              <div className="col-md-4 text-center">
                <img
                  
                  src={galleryImg1}
                  alt="gallery"
                  className="img-fluid extra-card-data"
                  style={{
                    width: '350px',
                    height: '350px',
                    objectFit: 'cover',
                    marginTop: '-170px'
                  }}
                
                />
              </div>

              {/* Content Section */}
              <div className="col-md-8">
                <h2 style={{
                  color: 'rgb(236 115 34)',
                  fontSize: '18px',
                  textAlign: 'justify',
                  fontWeight: 'bold'
                }} className="extra-data-order-healths">
                  In addition to the above compliance offering, DREBCON has commendable experience in implementing the MDSAP
                </h2>
                <ul style={{ textAlign: 'justify',color: '#000', }} className="extra-data-order-health">
                  <li>
                    At DREBCON, we streamline your journey to MDSAP (Medical Device Single Audit Program) compliance, enabling seamless access to global markets by meeting the regulatory requirements of participating countries through a single, unified audit process.
                  </li>
                  <li style={{ marginTop: '10px' }}>
                    Our expertise ensures robust quality management systems, mitigates compliance risks, and enhances operational efficiency, empowering medical device manufacturers to thrive in a highly regulated and competitive global marketplace.
                  </li>
                </ul>

                <button
                  style={styles.knowMoreButton}
                  onClick={handleKnowMoreClick}
                  onMouseEnter={(e) => (e.target.style.backgroundColor = "#e68a00")}
                  onMouseLeave={(e) => (e.target.style.backgroundColor = "rgb(236 115 34)")}>
                  Know More
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Responsive Styles */}
      <style jsx>{`
        /* Mobile View */
        @media (max-width: 768px) {
          .card {
            flex-direction: column; /* Stack the image and content */
            padding: 20px; /* Reduced padding */
            height: auto; /* Adjust height */
          }

          .col-md-4 {
            margin-bottom: 20px; /* Space between image and content */
            text-align: center; /* Center image */
          }

          .col-md-8 {
            text-align: center; /* Center content */
            padding: 0 10px; /* Padding adjustments */
          }

          img {
            width: 250px; /* Adjust image size for mobile */
            height: 250px; /* Adjust image size for mobile */
            margin-top: 0; /* Remove negative margin */
          }

          h2 {
            font-size: 18px; /* Smaller title font size */
          }

          ul {
            font-size: 16px; /* Smaller list items */
            padding-left: 20px; /* Adjust padding */
          }

          button {
            margin-left: 0; /* Adjust button alignment */
            display: block;
            margin-top: 20px;
            margin-left: auto;
            margin-right: auto;
          }
        }
      `}</style>
    </section>
  );
};

export default Healthcareextradata;
